module.exports = __webpack_public_path__ + "static/media/temporary-password.09e63f1b.svg";